import { ADMIN_API_ENV, ADMIN_API_PREVIEW, shouldUseAdminPublicApi } from '@/config/constants'

import { adminApiClient } from '../http/admin-api'
import { httpClient } from '../http/request'
import type { ImageModelConfigItem } from '../models/image-model'

const getImageModelParams = () => ({
  env: ADMIN_API_ENV,
  preview: ADMIN_API_PREVIEW
})

const getStoryImageModelParams = () => ({
  ...getImageModelParams(),
  storyOnly: true
})

function normalizeImageModelList(result: unknown): ImageModelConfigItem[] {
  if (Array.isArray(result)) return result
  if (result && typeof result === 'object' && Array.isArray((result as { data?: unknown }).data)) {
    return (result as { data: ImageModelConfigItem[] }).data
  }
  return []
}

async function fetchImageModels(params: Record<string, unknown>): Promise<ImageModelConfigItem[]> {
  const result = shouldUseAdminPublicApi()
    ? await adminApiClient.get('/api/public/image-models', { params })
    : await httpClient.get<ImageModelConfigItem[]>('/v1/lyart/image-models', { params })
  return normalizeImageModelList(result)
}

export const getImageModels = async (): Promise<ImageModelConfigItem[]> => {
  try {
    return await fetchImageModels(getImageModelParams())
  } catch (error) {
    console.error('[getImageModels] error:', error)
    return []
  }
}

export const getStoryImageModels = async (): Promise<ImageModelConfigItem[]> => {
  try {
    const params = getStoryImageModelParams()
    const list = await fetchImageModels(params)
    if (params.storyOnly) return list.filter(item => item.storyEnabled === true)
    return list
  } catch (error) {
    console.error('[getStoryImageModels] error:', error)
    return []
  }
}
